export default {
	setLoading(state, value) {
		state.loading = value;
	},
	setActivities(state, value) {
		state.activities = value;
	},
	filterWorkplace(state, value) {
		state.filterWord = value;
	},
};
